var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"options":_vm.options,"multiple":false,"searchable":false,"show-labels":false,"allow-empty":false,"max-height":180,"track-by":"id","label":"name","data-cy":"source","placeholder":""},model:{value:(_vm.selectedOption),callback:function ($$v) {_vm.selectedOption=$$v},expression:"selectedOption"}})
}
var staticRenderFns = []

export { render, staticRenderFns }